// extracted by mini-css-extract-plugin
export default {"container":"DeleteEmailModal_container__IGv0z","modalContent":"DeleteEmailModal_modalContent__xFCq-","modalFooter":"DeleteEmailModal_modalFooter__vLuRZ"};